import { MuiThemeProvider, withStyles } from "@material-ui/core/styles";
import React  from "react";

import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import styles from "./VoluntarRequestStyle";
import AppTheme from "../AppTheme";
import Input from "@material-ui/core/Input";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

import SwipeableViews from "react-swipeable-views";

import AppHeader from "../AppHeader/AppHeader";

import Paper from "@material-ui/core/Paper";

import { sendRequest } from "../services/volunteer";

var md5 = require("md5");

class VoluntarRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      agree: false,
      tabValue: 0,
      formInputData: {
        lastName: "",
        firstName: "",
        phoneNumber: "",
        emailAddress: ""
      },
      errors: {
        lastName: {
          hasError: false,
          isPristine: true,
          message: ""
        },
        firstName: {
          hasError: false,
          isPristine: true,
          message: ""
        },
        phoneNumber: {
          hasError: false,
          isPristine: true,
          message: ""
        },
        emailAddress: {
          hasError: false,
          isPristine: true,
          message: ""
        }
      }
    };
    this.sendRequest = this.sendRequest.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  validateForm = async () => {
    if (this.state.formInputData.firstName === "") {
      this.setState({
        error: "Nu ati completat prenumele."
      });
      return false;
    }

    if (this.state.formInputData.lastName === "") {
      this.setState({
        error: "Nu ati completat numele."
      });
      return false;
    }

    if (this.state.formInputData.phoneNumber === "") {
      this.setState({
        error: "Nu ati completat nr. telefon."
      });
      return false;
    }

    if (this.state.formInputData.emailAddress === "") {
      this.setState({
        error: "Nu ati completat adresa de email."
      });
      return false;
    }
    this.setState({
      error: ""
    });
    return true;
  };
  async sendRequest() {
    if (!this.validateForm()) return;
    var request = {
      firstName: this.state.formInputData.firstName,
      lastName: this.state.formInputData.lastName,
      emailAddress: this.state.formInputData.emailAddress,
      phoneNumber: this.state.formInputData.phoneNumber
    };
    await sendRequest(request);
    this.setState({ tabValue: 1 });
    return true;
  }

  handleChange(event) {
    const targetName = event.target.name;
    const value = event.target.value;
    this.setState(prevState => ({
      formInputData: {
        ...prevState.formInputData,
        [targetName]: value
      }
    }));
  }

  handleChangeCheckbox = name => event => {
    this.setState({
      [name]: event.target.checked
    });
  };

  handleFormFieldBlur = targetName => {
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [targetName]: {
          ...prevState.errors[targetName],
          isPristine: false
        }
      }
    }));
  };

  componentWillMount() {
    document.title = "Program Voluntariat - Vreau sa fiu voluntar";
  }

  render() {
    const { errors } = this.state;
    const { classes } = this.props;

    return (
      <MuiThemeProvider theme={AppTheme}>
        <div className={classes.bedsDashboard}>
          <AppHeader className={classes.appHeader} />
          <div
            style={{
              marginTop: "70px",
              display: "flex",
              flexDirection: "column",
              flex: "1",
              justifyContent: "flex-start",
              alignItems: "center"
            }}
          >
            <Paper
              style={{
                minWidth: "300px",
                maxWidth: "600px",
                marginTop: "30px",
                padding: "0 40px",
                display: "flex",
                paddingBottom: "20px",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <SwipeableViews
                axis={"x"}
                style={{ width: "100%" }}
                index={this.state.tabValue}
                animateHeight={false}
                ref={this.swipeableViewsRef}
                onChangeIndex={index => {
                  this.setState({ tabValue: index });
                }}
              >
                <div
                  style={{
                    alignContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                  }}
                >
                  <h1 style={{ marginTop: "50px" }}>
                    Vreau sa devin voluntar!
                  </h1>
                  <h3>Cerere de voluntariat</h3>
                  <p
                    style={{
                      margin: "20px 0 ",
                      fontStyle: "italic",
                      lineHeight: "1.2"
                    }}
                  >
                    Completand aceasta cerere sunteti de acord pentru a fi
                    contact de catre Spital MS Curie București - Secția Terapie
                    Intensivă Nou-Născuți si de catre ASOCIATIA "INIMA COPIILOR"
                    in vederea intocmirii unui contract de voluntariat in cadrul
                    programului "Niciun copil singur in spital". Inainte de a
                    semna contractul de voluntariat trebuie sa mai parcurgi doi
                    pasi: un interviu si un curs de voluntariat. <br />
                    <br />
                    Pentru mai multe detalii vizitati:{" "}
                    <a
                      href="https://www.e-neonat.ro/voluntariat-pag"
                      target="_blank"
                    >
                      {" "}
                      Pagina e-Neonat - Program Voluntariat
                    </a>
                  </p>
                  <Button target="_blank" color="primary" variant="contained" href="./InimaCopiilor_ContractDeVoluntariat.pdf">DESCARCA CONTRACTUL DE VOLUNTARIAT</Button>

                  <Grid
                    container
                    style={{ flex: 1, flexGrow: 1, width: "100%" }}
                    spacing={8}
                  >
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <FormControl
                        error={errors.lastName.hasError}
                        fullWidth={true}
                      >
                        <InputLabel htmlFor="lastName">Nume</InputLabel>
                        <Input
                          inputProps={{
                            name: "lastName",
                            id: "lastName"
                          }}
                          required={true}
                          value={this.state.formInputData.lastName}
                          onChange={this.handleChange}
                          onBlur={() => this.handleFormFieldBlur("lastName")}
                        />
                        <FormHelperText>
                          {errors.lastName.message}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <FormControl
                        error={errors.firstName.hasError}
                        fullWidth={true}
                      >
                        <InputLabel htmlFor="firstName">Prenume</InputLabel>
                        <Input
                          inputProps={{
                            name: "firstName",
                            id: "firstName"
                          }}
                          required={true}
                          value={this.state.formInputData.firstName}
                          onChange={this.handleChange}
                          onBlur={() => this.handleFormFieldBlur("firstName")}
                        />
                        <FormHelperText>
                          {errors.firstName.message}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <FormControl
                        error={errors.phoneNumber.hasError}
                        fullWidth={true}
                      >
                        <InputLabel htmlFor="phoneNumber">
                          Numar Telefon
                        </InputLabel>
                        <Input
                          inputProps={{
                            name: "phoneNumber",
                            id: "phoneNumber"
                          }}
                          required={true}
                          value={this.state.formInputData.phoneNumber}
                          onChange={this.handleChange}
                          onBlur={() => this.handleFormFieldBlur("phoneNumber")}
                        />
                        <FormHelperText>
                          {errors.phoneNumber.message}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <FormControl
                        error={errors.emailAddress.hasError}
                        fullWidth={true}
                      >
                        <InputLabel htmlFor="emailAddress">
                          Adresa Email
                        </InputLabel>
                        <Input
                          inputProps={{
                            name: "emailAddress",
                            id: "emailAddress"
                          }}
                          required={true}
                          value={this.state.formInputData.emailAddress}
                          onChange={this.handleChange}
                          onBlur={() =>
                            this.handleFormFieldBlur("emailAddress")
                          }
                        />
                        <FormHelperText>
                          {errors.emailAddress.message}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.agree}
                            onChange={this.handleChangeCheckbox("agree")}
                            value="agree"
                          />
                        }
                        label="Sunt de acord cu prelucrarea datelor de catre Spital MS Curie București - Secția Terapie Intensivă
              Nou-Născuți cu caracter confidential"
                      />
                    </Grid>
                  </Grid>
                  <Button
                    className={classes.sendButton}
                    variant="outlined"
                    disabled={!this.state.agree}
                    color="primary"
                    onClick={this.sendRequest}
                  >
                    Trimite Cerere
                  </Button>
                  <p style={{ marginTop: "20px", color: "#f00" }}>
                    {this.state.error}
                  </p>
                </div>
                <div
                  style={{
                    alignContent: "center",
                    display: "flex",
                    flex:1,
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height:"100%",
                    padding:40
                  }}
                >
                  <h1>Va multumim!</h1>
                  <h3 style={{marginTop:50, textAlign:"center"}}>Veti fi contactat pentru a stabili impreuna programarea interviului si data cand veti putea participa la curs.</h3>
                  <p><a
                  href="https://www.e-neonat.ro/voluntariat-pag"
                  target="window"
                >
                  {" "}
                  Pagina e-Neonat - Program Voluntariat
                </a>{" "}</p>
                </div>
              </SwipeableViews>
            </Paper>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(VoluntarRequest);
